import api from "../../../../../api/api"


const updateAddressColumns = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.get("import/tally/address/update").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const databaseUpdateServices = {
    updateAddressColumns,
}

export default databaseUpdateServices;